
import React from 'react';
import PropTypes from 'prop-types';

const MIDDLE = 50;
const MINIMUM = 0;

const SoundButton = props => {
  const { volumeLevel } = props; /* from 0 to 100 */
  return (
    <svg viewBox="0 0 20 18" focusable="false">
      <path className="sound-btn-base" d="M8.3.3L3 5.6H1a1 1 0 0 0-1 1.1v4.6a1 1 0 0 0 1 1.1h2l5.3 5.3c.7.7 1.7.1 1.7-.9V1.2c0-1-1-1.6-1.7-.9z" />
      <path className={volumeLevel > MIDDLE ? 'volume' : ''} d="M18 9a7.6 7.6 0 0 1-2.9 6.1 1.1 1.1 0 0 0-.1 1.5 1.1 1.1 0 0 0 1.4.1 10 10 0 0 0 0-15.4 1.1 1.1 0 0 0-1.4.1 1.1 1.1 0 0 0 .1 1.5A7.6 7.6 0 0 1 18 9z" />
      <path className={volumeLevel > MINIMUM ? 'volume' : ''} d="M14 9a4 4 0 0 1-1.7 3.2 1 1 0 0 0-.1 1.6 1 1 0 0 0 1.3.1 6.1 6.1 0 0 0 0-9.8 1 1 0 0 0-1.3.1 1 1 0 0 0 .1 1.6A4 4 0 0 1 14 9z" />
      <path className={`cross ${volumeLevel === MINIMUM ? 'volume' : ''}`} d="M17.1 9l2.2-2.1a1.2 1.2 0 0 0 0-1.4 1.1 1.1 0 0 0-1.5 0l-2.1 2.1-2.1-2.1a1 1 0 1 0-1.4 1.4L14.3 9l-2.1 2.1a1 1 0 1 0 1.4 1.4l2.1-2.1 2.1 2.1a1.1 1.1 0 0 0 1.5 0 1.2 1.2 0 0 0 0-1.4z" />
    </svg>
  );
};

if (process.env.NODE_ENV !== 'production') {
  SoundButton.propTypes = {
    volumeLevel: PropTypes.number.isRequired,
  };
}

export default SoundButton;
